var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVstx96 = function SvgVstx96(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M82 12V6H24v78h6v6h58V12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M52 50v10H42V50zm2-2H40v14h14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3955A3",
    d: "M82 6H24v12h58v-8l6 6v-4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    d: "M86 14v74H32v-4h50V18h-2v64H26V18h-2v66h6v6h58V16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M67 64c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5m0-2a7 7 0 1 0 0 14 7 7 0 0 0 0-14M61 32c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5m0-2a7 7 0 1 0 0 14 7 7 0 0 0 0-14M68 54H54v2h14z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M68 56h-2v8h2zM62 42h-2v14h2zM33 24a1 1 0 1 0-.001 1.999A1 1 0 0 0 33 24M39 24a1 1 0 1 0-.001 1.999A1 1 0 0 0 39 24M45 24a1 1 0 1 0-.001 1.999A1 1 0 0 0 45 24M51 24a1 1 0 1 0-.001 1.999A1 1 0 0 0 51 24M57 24a1 1 0 1 0-.001 1.999A1 1 0 0 0 57 24M73 34a1 1 0 1 0-.001 1.999A1 1 0 0 0 73 34M73 40a1 1 0 1 0-.001 1.999A1 1 0 0 0 73 40M73 46a1 1 0 1 0-.001 1.999A1 1 0 0 0 73 46M73 52a1 1 0 1 0-.001 1.999A1 1 0 0 0 73 52M73 58a1 1 0 1 0-.001 1.999A1 1 0 0 0 73 58M57 74a1 1 0 1 0-.001 1.999A1 1 0 0 0 57 74M51 74a1 1 0 1 0-.001 1.999A1 1 0 0 0 51 74"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3955A3",
    d: "m8 34 40-6v52L8 74z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m39 43-8.062 23h-5.974L17 43h5.68l4.88 16.007q.39 1.3.473 2.294h.097q.114-1.075.506-2.358L33.484 43z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vstx_96_svg__a",
    x1: 35.508,
    x2: 36.355,
    y1: 85.837,
    y2: 77.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#828282",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#7e7e7e",
      stopOpacity: 0.0341
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    style: {
      stopColor: "#717171",
      stopOpacity: 0.0694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    style: {
      stopColor: "#5d5d5d",
      stopOpacity: 0.1053
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    style: {
      stopColor: "#404040",
      stopOpacity: 0.1415
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    style: {
      stopColor: "#1b1b1b",
      stopOpacity: 0.1778
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    style: {
      stopColor: "#000",
      stopOpacity: 0.2
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vstx_96_svg__a)",
    d: "M48 86H24v-9.6L48 80z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vstx_96_svg__b",
    x1: 25.998,
    x2: 80.002,
    y1: 16.439,
    y2: 85.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 0.0226
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 0.0363
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    style: {
      stopColor: "#e6e6e6",
      stopOpacity: 0.0475
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    style: {
      stopColor: "#d1d1d1",
      stopOpacity: 0.0574
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    style: {
      stopColor: "#b7b7b7",
      stopOpacity: 0.0665
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#979797",
      stopOpacity: 0.075
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#707070",
      stopOpacity: 0.083
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    style: {
      stopColor: "#444",
      stopOpacity: 0.0906
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    style: {
      stopColor: "#121212",
      stopOpacity: 0.0976
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vstx_96_svg__b)",
    d: "M24 18h58v66H24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vstx_96_svg__c",
    x1: 46.856,
    x2: 87.943,
    y1: 37.457,
    y2: 90.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 0.0226
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 0.0363
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    style: {
      stopColor: "#e6e6e6",
      stopOpacity: 0.0475
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    style: {
      stopColor: "#d1d1d1",
      stopOpacity: 0.0574
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    style: {
      stopColor: "#b7b7b7",
      stopOpacity: 0.0665
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#979797",
      stopOpacity: 0.075
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#707070",
      stopOpacity: 0.083
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    style: {
      stopColor: "#444",
      stopOpacity: 0.0906
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    style: {
      stopColor: "#121212",
      stopOpacity: 0.0976
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vstx_96_svg__c)",
    d: "M82 10v74H30v6h58V16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vstx_96_svg__d",
    x1: 56,
    x2: 56,
    y1: 89.813,
    y2: 84.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#828282",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    style: {
      stopColor: "#7f7f7f",
      stopOpacity: 0.0281
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#777",
      stopOpacity: 0.045
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#696969",
      stopOpacity: 0.059
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    style: {
      stopColor: "#545454",
      stopOpacity: 0.0713
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    style: {
      stopColor: "#3a3a3a",
      stopOpacity: 0.0826
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    style: {
      stopColor: "#1a1a1a",
      stopOpacity: 0.0929
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vstx_96_svg__d)",
    d: "M30 84h52v6H30z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vstx_96_svg__e",
    x1: 55.678,
    x2: 56.331,
    y1: 17.154,
    y2: 4.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.2134
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.25
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vstx_96_svg__e)",
    d: "M82 6H24v12h58v-8l6 6v-4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vstx_96_svg__f",
    x1: 28,
    x2: 28,
    y1: 78.375,
    y2: 29.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.1546
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.18
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vstx_96_svg__f)",
    d: "M48 28 8 34v40l40 6z"
  })));
};
export default SvgVstx96;